import styled from 'styled-components';
import OverViewCard from './OverviewCard';
import React from 'react';
import {white} from '../../Theme';
import {device} from '../../constants/breakpoints';
import {PlanOfActionDesktopFooter} from './PlanOfActionFooter';
import { ProgressBarChart } from '../../components/ProgressBarChart/ProgressBarChart';

const StyledExecutiveFunctionsCard = styled.div`
    display: ${({$type, $activeTab}) => $type === $activeTab ? "flex" : "none"};
    justify-content: center;
    gap: 20px;
    max-width: 1280px;
    margin: 0 auto;
    width: 100%;
    
    @media screen and ${device.laptopL} {
        flex-direction: column;
        align-items: center;
    }
`;

const BarChartCard = styled.div`
    flex: 1;
    max-width: 55%;
    background-color: ${white};
    display: flex;
    flex-direction: column;

    @media screen and ${device.laptopL} {
        flex-basis: auto;
        max-width: 590px;
        width: 100%;
        height: auto;
    }
`;

const BarChartOuter = styled.div`
    width: 100%;
    height: 100%;

    @media screen and ${device.laptopL} {
        aspect-ratio: 1 / 1;

        @supports not (aspect-ratio: 1 / 1) {
            position: relative;
            overflow: hidden;
            padding-top: 100%;
        }
    }
`;

const BarChartInner = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    container-type: inline-size;

    @media screen and ${device.laptopL} {
        @supports not (aspect-ratio: 1 / 1) {
            position: absolute;
            inset: 0;
        }
    }
`;

export function ExecutiveFunctionsCard({period, activeTab, type, ...props}) {
    return (
        <StyledExecutiveFunctionsCard $type={type} $activeTab={activeTab}>
            <BarChartCard>
                <BarChartOuter>
                    <BarChartInner>
                        <ProgressBarChart data={period} />
                    </BarChartInner>
                </BarChartOuter>
                <PlanOfActionDesktopFooter {...props} />
            </BarChartCard>
            <OverViewCard period={period} {...props} />
        </StyledExecutiveFunctionsCard>
    );
}